export const EcommerceSignalMetricChangeDirection = {
    Grew: "Grew",
    Declined: "Declined",
} as const;

export type EcommerceSignalMetricChangeDirection =
    (typeof EcommerceSignalMetricChangeDirection)[keyof typeof EcommerceSignalMetricChangeDirection];

export default EcommerceSignalMetricChangeDirection;
